module.exports = __webpack_public_path__ + "static/media/gstock.d03a4178.png";